import { initReactI18next } from 'react-i18next'
import i18n from 'i18next'
import LocizeBackend from 'i18next-locize-backend'

import { LOCIZE_ALLOWED_HOST, LOCIZE_API_KEY, LOCIZE_SAVE_MISSING } from './env'

if (process.env.NODE_ENV === 'development') {
  console.log('LOCIZE_SAVE_MISSING', LOCIZE_SAVE_MISSING)
  console.log('LOCIZE_ALLOWED_HOST', LOCIZE_ALLOWED_HOST)
}

const locizeOptions = Object.assign(
  {},
  {
    cdnType: 'pro',
    projectId: 'b0f636d9-e8e0-477c-895c-2a868e9230db',
    referenceLng: 'en',
    version: 'latest',
  },
  LOCIZE_API_KEY ? { apiKey: LOCIZE_API_KEY } : undefined,
  {
    allowedAddOrUpdateHosts: function (hostname) {
      if (process.env.NODE_ENV === 'development') {
        console.log('hostname', hostname)
      }

      if (!LOCIZE_ALLOWED_HOST) {
        return false
      }

      const regexp = new RegExp(`${LOCIZE_ALLOWED_HOST}$`)

      if (hostname.search(regexp) === -1) {
        return false
      }

      return true
    },
  }
)

i18n
  .use(LocizeBackend)
  .use(initReactI18next)
  .init({
    backend: locizeOptions,
    debug: process.env.NODE_ENV === 'development',
    defaultNS: 'CRMFrontend',
    fallbackLng: ['en', 'de'],
    interpolation: {
      escapeValue: false,
    },
    lng: 'en',
    ns: ['CRMFrontend'],
    parseMissingKeyHandler: key => key,
    react: {
      useSuspense: true,
    },
    saveMissing: !!LOCIZE_SAVE_MISSING,
  })

export default i18n
